import { render, staticRenderFns } from "./InventoryFormFormFields.vue?vue&type=template&id=02a9c1aa"
import script from "./InventoryFormFormFields.vue?vue&type=script&lang=js"
export * from "./InventoryFormFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports